import { useThemeStore } from "components/main/stores/themeStore";
import loadingLight from "@/assets/images/mycorr_loading.gif";
import loadingDark from "@/assets/images/loading_dark.gif";

export const useThemedLoading = () => {
  const theme = useThemeStore((state) => state.theme);
  return theme === "dark" ? loadingDark : loadingLight;
};
